export interface Configuration {
  roofType: string; // platdak, modern, basic, or kapschuur
  columns?: number;
  dimensions: Dimensions;
  parapet: Parapet;
  roof: Roof;
  gutter: Gutter;
  walls: Wall[];
  storages: { 
    left: boolean; 
    right: boolean;
    leftLuifelEnabled?: boolean;
    rightLuifelEnabled?: boolean;
  };
  optionsMaterial: OptionsMaterial;
  params: Params;
}

export interface Params {
  platdakColumn: number; // width column of platdak, constant
  kapschuurColumn: number; // width column of kapschuur, constant
  kapschuurRoofThickness: number; // thickness of kapschuur roof above front column
  kapschuurOverhang: number; // kapschuur front overhang, calculated
  kapschuurOverhangLength: number; // length of kapschuur roof overhang, constant
  kapschuurOverhangSmallAngle: number; // angle between kapschuur roof overhang and perpendicular to front column, constant
  kapschuurOverhangBigAngle: number; // angle between kapschuur roof and back column, constant
  kapschuurBigHeight: number; // calculated
  kapschuurSmallHeight: number; // constant (doorloophoogte mm)
  kapschuurNokLabelMm?: number;
}

export interface Dimensions {
  width: number;
  depth: number;
  height: number;
  angle: number;
  overhangBack: number;
  overhangFront: number;
  overhangLeft: number;
  overhangRight: number;
  leftStorageWidth: number;
  rightStorageWidth: number;
}

export interface OptionsMaterial {
  liter_beits_zwart: number;
  liter_beits_wit: number;
  liter_beits_gray: number;
  liter_beits_douglas: number;
  poer: string;
  poerQuantity: number;
  daktrim_blank: boolean;
  daktrim_zwart: boolean;
  daktrim_empty: boolean;
  shorenType: "default" | "filled";
  montage: boolean;
  hemelwaterafvoer_pvc: boolean;
  betonband_antraciet: number;
}

export interface Parapet {
  enabled: boolean;
  height: number;
  type: string;
}

export interface Gutter {
  enabled: boolean;
  type: string;
}

export interface Roof {
  type: string;
  walls: { [key: string]: RoofWall };
  epdmGlue: boolean;
}

export interface RoofWall {
  name: string;
  rotate: boolean;
  innerWallEnabled: boolean;
  innerWallType: string;
  outerWallType: string;
  window: string;
}

export interface Wall {
  id: string;
  position: Position;
  isRightSide: boolean;
  inner: boolean;
  storage: string;
  slidingGlassWall: string;
  slidingGlassWallOptions: SlidingGlassWallOptions;
  woodWall: WoodWall;
  elementWall: ElementWall;
}

export interface SlidingGlassWallOptions {
  doorBrushes: number;
  stainlessSteelHandle: number;
  lockProfile: number;
  schuifrichting: string;
  contributors: number;
  glasbok: number;
  glassColor: string;
}

export const DEFAULT_SLIDING_GLASS_WALL_OPTIONS: SlidingGlassWallOptions = {
  doorBrushes: 0,
  stainlessSteelHandle: 0,
  lockProfile: 0,
  schuifrichting: "empty",
  contributors: 0,
  glasbok: 0,
  glassColor: "zwart",
};

export interface WoodWall {
  side: "left" | "right"; // door and window side
  innerColor: string; // color inner coating
  outerColor: string; // color outer coating
  rotate: boolean; // rotate wall on 180 deg
  window: string;
  door: string;
  doorSide: string;
}

export interface ElementWall {
  side: "left" | "right";
  innerColor: string;
  outerColor: string;
  elements: string[];
}

export interface Position {
  start: Coordinate;
  end: Coordinate;
}

export interface Coordinate {
  x: number;
  y: number;
}

export type PriceCategory = "A" | "B" | "NVT";

export interface DataItem {
  name: string;
  label: string;
  unit: string;
  quantity: number;
  price: number;
  total: number;
  category?: PriceCategory;
}
